import AntDropdown from 'antd-core/es/dropdown';
import styled from 'styled-components';
import { withInjectedClassName } from '../../hocs/withInjectedClassName/withInjectedClassName.js';

const Root = styled(withInjectedClassName(AntDropdown, 'overlayClassName')) `
  &.tend-ui-dropdown .tend-ui-dropdown-menu,
  &.tend-ui-dropdown-menu-submenu .tend-ui-dropdown-menu {
    padding: 0px;
    overflow: hidden;
  }

  &.tend-ui-dropdown .tend-ui-dropdown-menu .tend-ui-dropdown-menu-item,
  &.tend-ui-dropdown-menu-submenu .tend-ui-dropdown-menu .tend-ui-dropdown-menu-item,
  &.tend-ui-dropdown .tend-ui-dropdown-menu .tend-ui-dropdown-menu-submenu-title,
  &.tend-ui-dropdown-menu-submenu
    .tend-ui-dropdown-menu
    .tend-ui-dropdown-menu-submenu-title {
    border-radius: 0px;
  }

  &.tend-ui-dropdown .tend-ui-dropdown-menu .tend-ui-dropdown-menu-item-group-list,
  &.tend-ui-dropdown-menu-submenu
    .tend-ui-dropdown-menu
    .tend-ui-dropdown-menu-item-group-list {
    margin: 0px;
  }

  &.tend-ui-dropdown .tend-ui-dropdown-menu .tend-ui-dropdown-menu-item-group-title,
  &.tend-ui-dropdown-menu-submenu
    .tend-ui-dropdown-menu
    .tend-ui-dropdown-menu-item-group-title {
    font-size: 12px;
  }
`;
const Content = styled.div `
  border-radius: 12px;
  padding: 16px;
  background: white;
  box-shadow: 0px 0px 32px 0px rgba(0, 0, 0, 0.1);
`;

export { Content, Root };
//# sourceMappingURL=styled.js.map
